enum Spacing {
	NONE = 0,
	ONE = 8,
	TWO = 16,
	THREE = 24
}

export default Spacing;
